export default function (app) {
	app.directive ('ignoreMouseWheel', () => {
		return {
			restrict: 'A',
			link: (scope, element) => {
				element.bind('mousewheel', () => {
					element.blur();
				});
			}
		}
	});
}

